module.exports = __webpack_public_path__ + "img/TS.9e8bfce4.svg";